import React, { useState } from 'react';

import './Dropdown.scss';

interface DropdownProps {
  label?: string;
  color?: 'one' | 'two' | 'three' | 'four' | 'five' | 'six' | 'white' | 'black';
  change?: (value: any) => void;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  children: React.ReactNode;
  defaultKey?: string;
  defaultValue?: string;
}

export function Dropdown(props: DropdownProps) {
  const [value, setValue] = useState<string>(props.defaultValue || '');
  const [, setKey] = useState<string>(props.defaultKey || '');

  const childrenItems: any = React.Children.map(props.children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child);
    }

    return child;
  });

  const handleDropdownContent = (e: any) => {
    if (!props.disabled && e.target.nodeName.toLowerCase() === 'div') {
      if (e.target.classList.contains('dropdown-content-item')) {
        if (props.change) {
          props.change(e.target.childNodes[0].getAttribute('data-id'));
        }
        setKey(e.target.childNodes[0].getAttribute('data-id'));
        setValue(e.target.childNodes[0].innerText);
        e.target.parentNode.parentNode.classList.remove('open');
      } else {
        e.target.classList.toggle('open');
      }
    } else if (!props.disabled && e.target.nodeName.toLowerCase() === 'svg') {
      if (e.target.classList.contains('dropdown-content-item')) {
        if (props.change) {
          props.change(e.target.childNodes[0].getAttribute('data-id'));
        }
        setKey(e.target.childNodes[0].getAttribute('data-id'));
        setValue(e.target.childNodes[0].innerText);
        e.target.parentNode.parentNode.classList.remove('open');
      } else {
        e.target.parentNode.classList.toggle('open');
      }
    }
  };

  const handleOnClick = (e: any) => {
    if (!props.disabled) {
      if (props.change) {
        props.change(e.target.getAttribute('data-id'));
      }
      setKey(e.target.getAttribute('data-id'));
      setValue(e.target.innerText);
      e.target.parentNode.parentNode.parentNode.classList.remove('open');
    }
  };

  return (
    <div
      onClick={handleDropdownContent}
      className={`dropdown-item dropdown color-${props.color || 'none'} size-${
        props.size || 'medium'
      } ${props.disabled ? 'disabled' : ''}`}
    >
      {value ? value : props.label}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className="dropdown-item"
      >
        <path d="M7 10l5 5 5-5z"></path>
        <path d="M0 0h24v24H0z" fill="none"></path>
      </svg>
      <div className="dropdown-item dropdown-content">
        {childrenItems.map((item: any, index: number) => {
          return (
            <div key={index} className="dropdown-content-item" onClick={handleOnClick}>
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
}
